import AboutWapper from "../../../components/About/AboutWrapper";

const About: React.FC = () => {
  return <AboutWapper />; 
};

export default About;

